// ** Performance Optimized Icon Component
// Komponent z wszystkimi optymalizacjami dla Core Web Vitals

import React, { memo } from "react";
import BaseIcon from "../BaseIcon";
import useOptimizedIcon from "./useOptimizedIcon";

// #####################################################

/**
 * Performance Optimized Icon Component
 */
export const LazyIcon = memo(
	({
		name,
		variant = "solid",
		strategy = "lazy",
		fallback = null,
		debounce = 50,
		...iconProps
	}) => {
		// Wybór strategii ładowania
		const useStrategy = strategy === "lazy" || strategy === "preload";

		const { iconData, error, isReady } = useOptimizedIcon(name, variant, {
			enableLazyLoading: useStrategy,
			fallbackIcon: fallback,
			preload: strategy === "preload",
			debounceMs: debounce,
		});

		// Error state
		if (error && !iconData) {
			if (process.env.NODE_ENV === "development") {
				console.warn(`Icon loading error for "${name}":`, error);
			}

			// Render fallback lub nic
			if (fallback) {
				return (
					<BaseIcon
						name={fallback}
						variant={variant}
						{...iconProps}
					/>
				);
			}

			return null;
		}

		// Success state
		if (isReady || !useStrategy) {
			return <BaseIcon name={name} variant={variant} {...iconProps} />;
		}

		return null;
	},
);

// #####################################################

LazyIcon.displayName = "LazyIcon";

// #####################################################
